import { useFormContext, Controller } from 'react-hook-form';
import { RadioGroup, RadioGroupItem } from '../ui/RadioGroup';
import { Label } from '../ui/Label';
import { cn } from '../../lib/utils';

// ----------------------------------------------------------------------

type Props = {
  name: string;
  options: { label: string; value: string }[];
  label?: string;
  row?: boolean;
  spacing?: number;
  helperText?: React.ReactNode;
  className?: string;
  disabled?: boolean;
};

export default function RHFRadioGroup({
  row,
  name,
  label,
  options,
  spacing: _spacing,
  helperText,
  className,
  disabled
}: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <fieldset className={cn('space-y-1', className)}>
          {label && (
            <legend className={cn('text-sm font-medium', error && 'text-destructive')}>
              {label}
            </legend>
          )}

          <RadioGroup
            value={field.value}
            onValueChange={field.onChange}
            disabled={disabled}
            className={cn(row && 'flex flex-wrap items-center gap-4')}
          >
            {options.map((option) => (
              <div key={option.value} className="flex items-center space-x-2">
                <RadioGroupItem value={option.value} id={`${name}-${option.value}`} />
                <Label
                  htmlFor={`${name}-${option.value}`}
                  className="text-sm font-normal cursor-pointer"
                >
                  {option.label}
                </Label>
              </div>
            ))}
          </RadioGroup>

          {(error || helperText) && (
            <p className={cn('text-sm', error ? 'text-destructive' : 'text-muted-foreground')}>
              {error ? error.message : helperText}
            </p>
          )}
        </fieldset>
      )}
    />
  );
}
